import { DeterministicWrapperView } from '@bingads-webui/deterministic-wrapper-view';
import { pgridFactory } from '@bingads-webui-campaign/pgrid-factory';
import { updateGridQuery } from '@bingads-webui-campaign/summary-grid-helper';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { merge } from '@bingads-webui-universal/primitive-utilities';

const { handleSortChange } = globalContext.require('campaignui/feature/bingadsgrid/service/state-manager-helper');

export class NegativeKeywordListsKeywordGrid extends DeterministicWrapperView {
  viewFactory({
    scope,
    i18n,
    filterService,
    preferenceConfig,
    getGridConfig,
    setupDataSourceErrorHandling,
    getPlugins,
  }) {
    this.scope = scope;
    this.i18n = i18n;
    this.filterService = filterService;

    setupDataSourceErrorHandling(this);

    const gridConfig = merge(getGridConfig(this), preferenceConfig);

    this.grid = pgridFactory({
      gridConfig,
      plugins: getPlugins(this),
      preferenceConfig,
    });

    this.filterService.on('filter-state-changed', () => {
      updateGridQuery(
        this.grid.gridView,
        this.filterService.getCombinedFilter(), true
      );
    });

    this.grid.gridView.on('willUpdate', (changes) => {
      // a preference patch is sent while grid is being loaded
      // to avoid that only handle sort change when the grid is ready
      const { _isRendered } = this.grid.gridView;
      if (_isRendered) {
        handleSortChange(changes, this.grid.gridView, gridConfig.name);
      }
    });

    return this.grid.gridView;
  }
  get className() { return 'negative-keyword-lists-keyword-grid'; }

  renderTrunk() {
    this.filterService.refreshSource();
    this.filterService.initializeCombinedFilterPromise.then(() => {
      updateGridQuery(
        this.grid.gridView,
        this.filterService.getCombinedFilter(), true
      );
    });
    super.renderTrunk();
  }

  remove() {
    this.gridRemoved = true;
    return super.remove();
  }
}
